const SvgData1 = (props) => (
  <>
    <circle cx={48} cy={16} r={12} fill={props.p40} />
    <circle cx={80} cy={80} r={12} fill={props.p40} />
    <circle cx={48} cy={80} r={12} fill={props.p40} />
    <circle cx={80} cy={48} r={12} fill={props.p40} />
    <circle cx={16} cy={48} r={12} fill={props.p40} />
    <circle cx={16} cy={16} r={12} fill={props.p40} />
    <circle cx={48} cy={48} r={12} fill={props.p40} />
    <circle cx={16} cy={80} r={12} fill={props.p40} />
    <circle cx={80} cy={16} r={12} fill={props.p40} />
  </>
);

export default SvgData1;
